/**
 * Renewing self-funding access from Your Plan. The paywall shows the renewal offer with the Checkout
 * Session's amount and the 365-day line before anything is paid; Back from it returns to Your Plan,
 * and after paying the consumer comes back to Your Plan with their saved accounts counted again.
 */
import { useConsumerFlow } from './use-consumer-flow';

export function useSelfFundRenewal(clientId: string) {
  const { goTo } = useConsumerFlow(clientId);
  return { renew: () => goTo('self-fund', { returnTo: 'your-plan' }) };
}
